import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/develop.svg";
import Particle from "../Particle";
import Home2 from "./Home2";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Wayne Jiang</strong>
              </h1>

              <div className="home-professional-intro">
                <p className="home-professional-role">
                  Backend-focused Full-Stack Software Engineer
                </p>
                <p className="home-professional-summary">
                  <strong>5+ years of experience</strong> building, deploying,
                  and maintaining software.
                </p>
                <p className="home-ai-focus">
                  AI agents · RAG · Reusable agent skills
                </p>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
